const theme: 'light' = 'light';

interface IColors {
  azulClaro: string;
  azulEscuro: string;
  cinzaEscuro: string;
  cinzaClaro: string;
  branco: string;
  vermelho: string;
}

export const getColors = (): IColors => {
  return {
    azulClaro: '#efa703 ',
    azulEscuro: '#efa703',
    cinzaEscuro: '#616161',
    cinzaClaro: '#f1f1f166',
    branco: '#ffffff',
    vermelho: '#B85151',
  };
};
